import './contactUs.css';
import ContactUsList from './ContactUsList';
import ContactUsSelect from './ContactUsSelect';
import { useDevice } from '../../contexts/DeviceContext';
import { getCurrentLayout } from '../../utils/ChooseLayout';
import { useFooterContent } from '../../graphql/pimcore/modules/siteContent/hooks/useFooterContent';

export default function ContactUs() {
    const { width } = useDevice();
    const layout = getCurrentLayout(width);
    const { loading, contentTree } = useFooterContent();

    if (loading) {
        return null;
    }

    return (
        <div className="contactUs-background">
            <div className="contactus-container">
                {layout === 'small' || layout === 'extra_small' ? (
                    <ContactUsSelect cmsContent={contentTree} />
                ) : (
                    <ContactUsList cmsContent={contentTree} />
                )}
            </div>
        </div>
    );
}
